import { useNotificationDetailsPath as resolveNotificationDetailsPath } from "./useNotificationDetailsPath";

export type RelatedEntityType =
  | "SECURITY_CLEARANCE"
  | "GATEPASS"
  | "VESSEL_REGISTRATION"
  | "VESSEL_CALL"
  | "MOVEMENT_SERVICE"
  | "MOVEMENT"
  | "DEPARTURE"
  | "INTERRUPTION"
  | "SHIPPING_AGENCY_TRANSFER"
  | string;

export const buildNotificationDetailsPath = (
  relatedEntityType?: RelatedEntityType,
  relatedEntityId?: string,
  secondRelatedEntityId?: string,
): string | null => {
  if (!relatedEntityType || !relatedEntityId) return null;

  switch (relatedEntityType) {
    case "SECURITY_CLEARANCE":
      return `/port-security/security-clearance-request-preview/${relatedEntityId}`;
    case "GATEPASS":
      return `/gatepass/gatepass-request-preview/${relatedEntityId}`;
    case "VESSEL_REGISTRATION":
      return `/vessel-management/vessel-status/${relatedEntityId}`;
    case "VESSEL_CALL":
      return `/vessel-call/vessel-call-status/${relatedEntityId}/vessel-details`;
    case "MOVEMENT_SERVICE":
    case "MOVEMENT":
      return `/vessel-call/vessel-call-status/${secondRelatedEntityId}/movement-services/${relatedEntityId}`;
    case "DEPARTURE":
      return `/vessel-call/vessel-call-status/${secondRelatedEntityId}/departure`;
    case "INTERRUPTION":
      return `/vessel-call/vessel-call-status/${relatedEntityId}/vessel-details`;
    case "SHIPPING_AGENCY_TRANSFER":
      return `/vessel-call/vessel-call-status/${relatedEntityId}/shipping-agency-transfer`;
    case "PORT_SERVICES":
      return `/vessel-call/vessel-call-status/${secondRelatedEntityId}/port-services/${relatedEntityId}`;
    case "DISPUTE":
      return `/vessel-call/vessel-call-status/${secondRelatedEntityId}/operations/disputes`;
    case "VENDOR_LICENSE":
      return resolveNotificationDetailsPath(relatedEntityId, "VENDOR_LICENSE");
    case "PORT_OPERATOR_LICENSE":
      return resolveNotificationDetailsPath(relatedEntityId);
    default:
      return null;
  }
};
